import { render, staticRenderFns } from "./Saraashop.vue?vue&type=template&id=6141fb94&"
import script from "./Saraashop.vue?vue&type=script&lang=js&"
export * from "./Saraashop.vue?vue&type=script&lang=js&"
import style0 from "./Saraashop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports